var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24"}},[_c('path',{attrs:{"d":"M280-400l200-200 200 200H280z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }